<template>
    <div class="bg-white px-3 index">
        <div class="pd">
            <el-card class="box-card" shadow="never">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form ref="form" label-width="80px" class="formeds">
                            <el-form-item label="时间:">
                                <el-select v-model="formData.timefw" placeholder="请选择" size="small" class="zwidths"
                                    @change="timechange">
                                    <el-option label="最近" value="1"></el-option>
                                    <el-option label="范围" value="2"></el-option>
                                </el-select>
                                <el-autocomplete class="zwidthed pd_lf" v-if="formData.timefw==1" type="text"
                                    @change="getbegin" size="small" v-model="formData.timeday"
                                    :fetch-suggestions="querySearch" placeholder="请输入内容">
                                    <i slot="suffix">天 </i>
                                </el-autocomplete>
                                <el-date-picker v-model="formData.fwtimes" class="pd_lf" value-format="yyyy-MM-dd"
                                    @change="getbegin(1)" type="daterange" v-if="formData.timefw==2" size="small"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    :clearable="false">
                                </el-date-picker>
                                <el-button icon="el-icon-refresh" size="small" class="pd_lf"
                                    @click="getbegin(formData.timefw==2?1:'')">
                                </el-button>
                            </el-form-item>
                            <el-form-item label="省份:">
                                <el-select v-model="formData.sfval" clearable filterable placeholder="请选择" size="small"
                                    @change="getbegin">
                                    <el-option v-for="item in formData.sf_options" :key="item.ip_province"
                                        :label="item.ip_province" :value="item.ip_province">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                    </el-col>
                    <el-col :span="12">
                        <el-form ref="form" label-width="80px" class="formeds" inline>
                            <el-form-item label="行为:">
                                <el-select v-model="formData.xwval" clearable filterable placeholder="请选择" size="small"
                                    @change="getbegin">
                                    <el-option v-for="item in formData.xw_options" :key="item.id" :label="item.behavior"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="模块:">
                                <el-select v-model="formData.mkval" clearable filterable placeholder="请选择" size="small"
                                    @change="getbegin">
                                    <el-option v-for="item in formData.mk_options" :key="item.id" :label="item.modular"
                                        :value="item.regular">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="用户:">
                                <el-select v-model="formData.user_value" clearable filterable placeholder="请选择"
                                    size="small" @change="getbegin">
                                    <el-option v-for="item in formData.user_options" :key="item.id"
                                        :label="item.doctorAudit?item.doctorAudit.real_name:item.nickname"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div class="pd" v-loading="loadings">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card class="box-card" shadow="never">
                        <div id="myChart" :style="{width: '100%', height: '300px'}"></div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card" shadow="never">
                        <div id="myCharts" ref="mycharts" :style="{width: '100%', height: '300px'}"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="pd">
            <el-card class="box-card" shadow="never" v-loading="loadings">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div id="regionCharts" :style="{width: '100%', height: '400px'}"></div>
                    </el-col>
                    <el-col :span="12">
                        <div class="dc_btn_b">
                            <el-button icon="el-icon-printer" :loading='dcing' size="mini" @click="exportModal = true">
                                导出Excel</el-button>
                        </div>
                        <el-table :data="tableData" height="400">
                            <el-table-column prop="create_user" label="ID" align="center"></el-table-column>
                            <el-table-column prop="create_time" label="时间" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="ip_province" label="省份" align="center"></el-table-column>
                            <el-table-column prop="modular_id_text" label="模块" align="center"></el-table-column>
                            <el-table-column prop="behavior_id_text" label="行为" align="center"></el-table-column>
                            <el-table-column prop="source_url" label="来源页面" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="url" label="前往页面" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="duration" label="停留时间" align="center"></el-table-column>
                            <el-table-column prop="username" label="操作人" align="center" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                        <div class="u-f u-ac u-jsb ft_mr">
                            <div></div>
                            <div>
                                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                                </el-pagination>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div style="height:100px"></div>

        <el-dialog title="导出数据" :visible.sync="exportModal" width="30%" center>
            <el-form :model="exportForm" ref="ruleForm">
                <el-form-item label="时间范围" prop="time">
                    <el-date-picker v-model="exportForm.time" type="date" size="small" value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='dcing' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    timefw: '1',
                    timeday: '7',
                    fwtimes: '',
                    xw_options: [],
                    mk_options: [],
                    restaurants: [{
                        value: "1"
                    }, {
                        value: "5"
                    }, {
                        value: "7"
                    }, {
                        value: "30"
                    }, {
                        value: "60"
                    }],
                    sfval: '',
                    sf_options: [],
                    user_options: [],
                    user_value: '',
                    mkval: '',
                    xwval: '',
                },
                loadings: false,
                weekData: [],
                provinceData: [],
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                exportModal: false,
                exportForm: {
                    time: '',
                },
                dcing: false
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            this.getbegin()
            this.getuser()
        },
        methods: {
            async getbegin(t) {
                if (t != 1) {
                    this.formData.fwtimes = this.gettime()
                }
                await this.getxwxx()
                // await this.getuser()
                await this.getmkxx()
                await this.getdq()
                await this.begin()
                this.drawLine()
                this.drawRig()
                this.drawregionCharts()

            },
            async getxwxx() {
                await axios.post("/admin/Behavior/getBehavior", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.xw_options = response.data.data
                    })
                    .catch(error => {})
            },
            async getmkxx() {
                await axios.post("/admin/Modular/getModular", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.mk_options = response.data.data
                    })
                    .catch(error => {})
            },
            async getuser() {
                this.formData.user_options = JSON.parse(localStorage.getItem('allUserList'))
            },
            // 
            async getdq() {
                await axios.post("/admin/BrowsingHistory/getBriwsingProvince", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 浏览记录
            async begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                await that.search()
            },
            async search() {
                this.loadings = true
                await axios.post("/admin/BrowsingHistory/index", {
                        page: this.currentPage,
                        page_count: this.pagesize,
                        source: 1,
                        start_time: this.formData.fwtimes[0],
                        end_time: this.formData.fwtimes[1],
                        ip_province: this.formData.sfval,
                        behavior_id: this.formData.xwval,
                        regular: this.formData.mkval,
                        user_id: this.formData.user_value
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.loadings = false
                        this.tableData = response.data.data.list
                        this.count = response.data.data.count
                        this.pageData = response.data.data.pageData
                        this.provinceData = response.data.data.provinceData
                        this.weekData = response.data.data.weekData
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            querySearch(queryString, cb) {
                cb(this.formData.restaurants);
            },
            drawLine() {
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                myChart.setOption({
                    title: {
                        text: '用户操作',
                    },
                    tooltip: {
                        trigger: 'item',
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'right',
                        y: 'center'
                    },
                    series: [{
                        name: '访问来源',
                        type: 'pie',
                        radius: '50%',
                        center: ['30%', '50%'],
                        label: {
                            normal: {
                                position: 'inner',
                                show: false
                            }
                        },
                        // color: ['#5ACEBB'],
                        data: this.pageData,
                        // [
                        // {
                        //     value: 1048,
                        //     name: '搜索引擎',
                        //     icon: 'rectangle'
                        // },
                        // {
                        //     value: 735,
                        //     name: '直接访问',
                        //     icon: 'circle'
                        // },
                        // ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                });
                window.addEventListener("resize", function () {
                    setTimeout(function () {
                        myChart.resize();
                    }, 500)
                });
            },
            drawRig() {
                var list = []
                list = this.weekData.map(ele => ele.day)
                let myChart = this.$echarts.init(document.getElementById('myCharts'))
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter(params) {
                            return params[0].data.day + '<br/>人数：' + params[0].data.value + '<br/>行为：' + params[
                                0].data.behavior_count + '<br/>新用户：' + params[0].data.new_behavior_count;
                        },
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    color: ["#3370FF"],
                    xAxis: [{
                        type: 'category',
                        data: list,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }],
                    yAxis: [{
                        type: 'value'
                    }],
                    series: [{
                        name: '柱状图',
                        type: 'bar',
                        barWidth: '60%',
                        data: this.weekData
                    }]
                })
                window.addEventListener("resize", function () {
                    setTimeout(function () {
                        myChart.resize();
                    }, 500)
                });
            },
            drawregionCharts() {
                let myChart = this.$echarts.init(document.getElementById('regionCharts'))
                myChart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            if (params.data) {
                                return params.name + '<br/>人数：' + params.data.value + '<br/>行为：' + params
                                    .data.behavior_count; //自行定义formatter格式  (人数/占比)
                            }
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: 1000,
                        left: 'left',
                        top: 'bottom',
                        text: ['高', '低'], //取值范围的文字
                        orient: 'horizontal', //控制条横向
                        inRange: {
                            color: ['#e0ffff', '#5D78F2'] //取值范围的颜色
                        },
                        show: true, //图注
                        // calculable: true, //是否显示拖把
                    },
                    geo: {
                        map: 'china',
                        roam: false, //不开启缩放和平移
                        zoom: 1.23, //视角缩放比例
                        label: {
                            // normal: { //显示地区名称
                            //     show: true,
                            //     fontSize: '10',
                            //     color: 'rgba(0,0,0,0.7)'
                            // },
                            emphasis: {
                                textStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            },
                            emphasis: {
                                areaColor: '#5D78F2', //鼠标选择区域颜色
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    series: [{
                        name: '信息量',
                        type: 'map',
                        geoIndex: 0,
                        data: this.provinceData
                    }]

                })
                window.addEventListener("resize", function () {
                    setTimeout(function () {
                        myChart.resize();
                    }, 500)
                });
            },
            // 
            timechange(val) {
                if (val == 2) {
                    this.formData.fwtimes = this.gettime()
                }
                this.getbegin()
            },
            gettime() {
                let nowDate = new Date()
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                let endTime = `${year}-${month}-${day}`;
                let befDate = new Date(nowDate.getTime() - this.formData.timeday * 24 * 3600 * 1000);
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                let bday = befDate.getDate();
                bmonth = bmonth > 9 ? bmonth : '0' + bmonth
                bday = bday > 9 ? bday : '0' + bday
                let startTime = `${byear}-${bmonth}-${bday}`;
                var fwtimes = [startTime, endTime]
                return fwtimes
            },
            // 导出数据
            exportExcel() {
                if (!this.exportForm.time) {
                    return this.$message({
                        type: "error",
                        message: "时间不能为空！"
                    })
                }
                this.dcing = true
                let url = `/admin/pc/Excel/logReport2Excel`
                let params = ''
                let val = this.exportForm.time
                if (val) {
                    params += `&starttime=${val}`
                }
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    this.exportModal = false
                    if (res.status == 200) {
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    }
                    this.dcing = false
                }).catch(err => {
                    this.dcing = false
                })
            },
        },
    };
</script>


<style scoped>
    .pd {
        padding: 10px 0;
    }

    .formeds .el-form-item {
        margin-bottom: 0px !important;
    }

    .zwidths {
        width: 88px;
    }

    .zwidthed {
        width: 66px;
    }

    .pd_lf {
        margin-left: 10px;
    }

    .dc_btn_b {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 5px;
    }
</style>